import { render, staticRenderFns } from "./AdminRoot.vue?vue&type=template&id=42c0e016&lang=pug&"
import script from "./AdminRoot.vue?vue&type=script&lang=js&"
export * from "./AdminRoot.vue?vue&type=script&lang=js&"
import style0 from "./AdminRoot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports